import React from "react";
import "./style.css";

function InactiveBook(props) {
  return (
    <div className="inactive justify-center z-10 items-center w-full opacity-75 bg-gray-700 flex relative inset-0 rounded-lg">
      <p className="text-center bold mb-2 text-orange-custom w-full">
        Waiting To Be Verified
      </p>
    </div>
  );
}

export default InactiveBook;
